import {useContext} from 'react';
import EventContext from '/context/EventContext.js';

export default function Details({id, classIdentifier}) {
    const {event} = useContext(EventContext);
    if (!event.custom_data?.details_html) {
        return null;
    }
    return (
        <section className={classIdentifier} id={id}>
            <div className='mt-8 pb-8 md:pb-24'>
              <p className='text-gray-dark text-sm xl:text-base mt-[21px]'>
                  {event.custom_data?.details_html?.split('\n').map((item, key) => {
                      return <span key={key}>{item}<br/></span>
                  })}
              </p>
            </div>
        </section>
    );
}
